<template>
    <div class="card">
        <div class="card-header">
            个人联系信息管理
        </div>
        <table class="table table-bordered mb-0">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 15%">电子邮箱</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.emailAddress}}</td>
                <th class="text-center align-middle" style="width: 15%">移动电话</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.mobilePhone}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">固定电话</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.phoneNumber}}</td>
                <th class="text-center align-middle" style="width: 15%">微信号码</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.weixin}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">QQ号码</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.qq}}</td>
                <th class="text-center align-middle" style="width: 15%">钉钉号码</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.dingding}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">传真号码</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.fax}}</td>
                <th class="text-center align-middle" style="width: 15%">邮政编码</th>
                <td class="text-left align-middle" style="width: 35%">{{personContactInfo.postCode}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">联系地址</th>
                <td class="text-left align-middle" colspan="3">{{personContactInfo.provinceName}} {{personContactInfo.cityName}} {{personContactInfo.contactAddress}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";

export default {
    name: "OrganPersonContactInfoView",
    props: {
        personId: {type: String, required: true},
    },
    data: function () {
        return {
            personContactInfo: {}
        };
    },
    mounted() {
        this.getPersonContactInfo();
    },
    methods: {
        getPersonContactInfo() {
            userApi.person.contact.getOrganContactInfo(this.personId).then(res => {
                this.personContactInfo = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>